const LocaleConfig = {}

export default LocaleConfig